import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import { t } from '../../i18n/i18n';
import ModalCustom from '../ModalCustom/ModalCustom';

export const ModalUserProfileEnabled = ({
  showModal,
  setShowModal,
  data: { requireCompletedProfile },
  submitAction,
  disabledButtonProps = false,
}) => {
  const [disabledButton, setDisabledButton] = useState(false);
  const onClickButton = () => {
    setDisabledButton(true);
    submitAction();
  };
  return (
    <>
      <ModalCustom
        onCancel={() => setShowModal(false)}
        onCancelText={t('CANCEL_OPERATION_LABEL')}
        onOk={disabledButtonProps && disabledButton ? () => {} : onClickButton}
        classModal="allow-certificate-download-modal-width"
        subtitleClassName="px-0 px-lg-0"
        onOkText={requireCompletedProfile ? t('DEACTIVATE_LABEL') : t('ACTIVATE_LABEL')}
        setShow={setShowModal}
        show={showModal}
        title={
          requireCompletedProfile
            ? t('WILL_DISABLE_COMPLETE_PROFILE')
            : t('WILL_ENABLE_COMPLETE_PROFILE')
        }
        subtitle={
          requireCompletedProfile
            ? t('TO_DISABLE_COMPLETE_PROFILE_DESCRIPTION_MODAL')
            : t('TO_ENABLE_COMPLETE_PROFILE_DESCRIPTION_MODAL')
        }
      />
    </>
  );
};
